import { render, staticRenderFns } from "./callHistory.vue?vue&type=template&id=304e2059"
import script from "./callHistory.vue?vue&type=script&lang=js"
export * from "./callHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports